import { differenceInYears, isBefore, parseISO, subYears } from 'date-fns';

export const isUnder18 = (birthDateString: string): boolean => {
	if (!birthDateString) return false;
	const birthDate = parseISO(birthDateString);
	const today = new Date();
	const age = differenceInYears(today, birthDate);

	if (age > 18) {
		return false;
	} else if (age < 18) {
		return true;
	} else {
		return isBefore(today, subYears(birthDate, -18));
	}
};
